import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATEGORIES = [
  { key: "decision", label: "Unfair Decision", desc: "A hiring, housing, medical, school, or law enforcement decision." },
  { key: "institutional", label: "Broken System", desc: "A policy or pattern inside one organization." },
  { key: "systemic", label: "Ongoing Pattern", desc: "The same bias showing up again and again." },
];

export function IncidentCategorySelect({ value, onChange, testId, optionTestId }) {
  return (
    <div>
      <Label className="text-zinc-500 text-xs uppercase tracking-wide mb-2 block">Category</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className="bg-white border-zinc-300 text-zinc-950 rounded-none focus:ring-1 focus:ring-[#4FD1C5]">
          <SelectValue placeholder="Choose a category" />
        </SelectTrigger>
        <SelectContent className="bg-white border-zinc-200 text-zinc-950">
          {CATEGORIES.map((c) => (
            <SelectItem key={c.key} value={c.key} data-testid={optionTestId(c.key)}>
              <div><p className="font-medium">{c.label}</p><p className="text-xs text-zinc-500">{c.desc}</p></div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
